import React, { Component } from 'react';
import { Form, Button, Input, Dimmer, Loader, Radio, Grid, List, ListItem } from 'semantic-ui-react';
import "react-datepicker/dist/react-datepicker.css";
import './ManageCalendar.css';
import { connect } from 'react-redux';
import { authAxios } from '../../utils';
import { UpdateSlots, GetAllFutureDatesURL, GetEmployeeInformationURL, } from '../../constants';
import { authContext } from '../../adalConfig';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import enUS from 'date-fns/locale/en-US';
import de from 'date-fns/locale/de';
import fr from 'date-fns/locale/fr';
import DualHeader from '../DualHeader';
import DualFooter from '../DualFooter';

let loginNameWithDomain = authContext.getCachedUser() ? authContext.getCachedUser().profile.upn : '';

// Specify max slots here, these are all over the place below.
const corpMaxSlots_US = 20;
const proMaxSlots_US = 25;
const fieldMaxSlots_US = 20;

const corpMaxSlots_CA = 5;
const proMaxSlots_CA = 2;
const fieldMaxSlots_CA = 15;

const corpMaxSlots_UK = 5;
const proMaxSlots_UK = 2;
const fieldMaxSlots_UK = 15;

const corpMaxSlots_Benelux = 5;
const proMaxSlots_Benelux = 2;
const fieldMaxSlots_Benelux = 15;

const corpMaxSlots_DE = 5;
const proMaxSlots_DE = 2;
const fieldMaxSlots_DE = 15;

const corpMaxSlots_FR = 5;
const proMaxSlots_FR = 2;
const fieldMaxSlots_FR = 15;

const corpMaxSlots_CH = 5;
const proMaxSlots_CH = 2;
const fieldMaxSlots_CH = 15;

const corpMaxSlots_IT = 5;
const proMaxSlots_IT = 2;
const fieldMaxSlots_IT = 15;

class ManageCalendar extends Component {
    constructor(props) {
        super();
        window.calcomp = this;
        this.handleCalClickBack = this.handleCalClickBack.bind(this);
        this.handleDayClick = this.handleDayClick.bind(this);
        this.handleEMEADayClick = this.handleEMEADayClick.bind(this);
        this.handleEmeaDateSelected = this.handleEmeaDateSelected.bind(this);
        this.handleNaDateSelected = this.handleNaDateSelected.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleLOBChange = this.handleLOBChange.bind(this);
    }

    state = {
        date: new Date(),
        loading: false,
        disabledDates: [],
        slotsPro: [],
        slotsCORP: [],
        slotsField: [],
        slotsEmeaField: [],
        slotsEmeaCORP: [],
        slotsEmeaPro: [],
        modifiedDatesCORP: [],
        modifiedDatesPro: [],
        modifiedDatesField: [],
        modifiedDatesEMEACorp: [],
        modifiedDatesEMEAField: [],
        modifiedDatesEMEAPro: [],
        LOB: [],
        region: [],
        country: '',
    }

    handleDayClick(day, modifiers = {}) {
        if (modifiers.disabled) {
            return;
        }
        this.setState({
            selectedDay: modifiers.selected ? undefined : day,
            error: true
        });
    }

    handleEMEADayClick(day, modifers = {}) {
        if (modifers.disabled) {
            return;
        }
        this.setState({
            emeaSelectedDate: modifers.selected ? undefined : day,
            error: true
        });
    } 

    componentDidMount() {
        this.setState({
            loading: true
        })

        authAxios.post(GetEmployeeInformationURL, {
            LoginNameWithDomain: loginNameWithDomain
        })
            .then(response => {
                let data = response.data
                this.setState({
                    region: data.region, country: data.country,
                    LOB: data.LOB
                })
                authAxios.get(GetAllFutureDatesURL, {
                })
                    .then(response => {
                        let data = response.data;
                        let disableDates = [];
                        disableDates.push({ daysOfWeek: [0, 2, 3, 4, 5, 6] });
                        disableDates.push({
                            before: this.DateNow()
                        });

                        let dataCORP = data.filter(item => (item.lob === 'CORP'));
                        let dataField = data.filter(item => (item.lob === 'FIELD'))
                        let dataPro = data.filter(item => (item.lob === 'PRO'))
                        let dataEmeaCORP = data.filter(item => (item.lob === 'EMEA CORP'))
                        let dataEmeaField = data.filter(item => (item.lob === 'EMEA FIELD'))
                        let dataEmeaPro = data.filter(item => (item.lob === 'EMEA PRO'))
                        if (this.state.region === 'NA') {
                            this.setState({
                                slotsCORP: this.getSlots(dataCORP),
                                slotsPro: this.getSlots(dataPro),
                                slotsField: this.getSlots(dataField),
                                disabledDates: disableDates,
                                loading: false,
                                LOB: 'CORP'
                            });
                        } else if (this.state.region === 'EMEA') {
                            this.setState({
                                slotsEmeaCORP: this.getSlots(dataEmeaCORP),
                                slotsEmeaField: this.getSlots(dataEmeaField),
                                slotsEmeaPro: this.getSlots(dataEmeaPro),
                                disabledDates: disableDates,
                                loading: false,
                                LOB: 'EMEA CORP'
                            });
                        }
                    })
            })
            .catch((error) => {
                this.setState({ loading: false });
            })
    }

    getSlots(slots) {
        let data = slots.map((x) => {
            return ({
                'DateTimeValue': x.dateTimeValue,
                'MaxSlotUS': x.maxSlotUS,
                'MaxSlotCA': x.maxSlotCA,
                'MaxSlotUK': x.maxSlotUK,
                'MaxSlotBenelux': x.maxSlotBenelux,
                'MaxSlotDE': x.maxSlotDE,
                'MaxSlotFR': x.maxSlotFR,
                'MaxSlotCH': x.maxSlotCH,
                'CurrentSlotUK': x.currentSlotCountUK,
                'CurrentSlotBenelux': x.currentSlotCountBenelux,
                'CurrentSlotDE': x.currentSlotCountDE,
                'CurrentSlotFR': x.currentSlotCountFR,
                'CurrentSlotCH': x.currentSlotCountCH,
                'CurrentSlotUS': x.currentSlotCountUS,
                'CurrentSlotCA': x.currentSlotCountCA,
            })
        });
        return data;
    }

    getDateFnsLocale(country) {
        switch (country) {
            case 'DE': return de;
            case 'FR': return fr;
            case 'IT': return it;
            default: return enUS;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { selectedDay, CAslot, USslot, slotUK, slotDE, slotFR, slotCH, slotBenelux } = this.state;
        if (selectedDay !== prevState.selectedDay) {
            this.date = this.state.selectedDay;
            this.setState({
                selectedDay
            })
        }
        if (CAslot !== prevState.CAslot) {
            this.setState({
                CAslot
            })
        }
        if (USslot !== prevState.USslot) {
            this.setState({
                USslot
            })
        }
        if (slotUK !== prevState.slotUK) {
            this.setState({
                slotUK
            })
        }
        if (slotDE !== prevState.slotDE) {
            this.setState({
                slotDE
            })
        }
        if (slotFR !== prevState.slotFR) {
            this.setState({
                slotFR
            })
        }
        if (slotCH !== prevState.slotCH) {
            this.setState({
                slotCH
            })
        }
        if (slotBenelux !== prevState.slotBenelux) {
            this.setState({
                slotBenelux
            })
        }
    }

    handleCalClickBack() {
        this.props.history.push('./WelcomePage');
    }

    handleSave() {
        authAxios.post(UpdateSlots, {
            SlotUpdate: this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP : this.state.LOB === 'PRO' ? this.state.modifiedDatesPro : this.state.LOB === 'EMEA PRO' ? this.state.modifiedDatesEMEAPro : this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesField,
            LOB: this.state.LOB
        }).then(response => {
            this.props.history.push('./WelcomePage');
        })
            .catch((error) => {
                console.log('error ' + error);
            });
    }

    onChange = async function (date) {
        await this.setState({ date: date });
        await this.setState({ selectedDay: this.date });
    }

    DateNow = () => {
        let today = new Date();
        let firstMondayOfTheCurrentWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1);
        return new Date(today.setDate(firstMondayOfTheCurrentWeek));
    }

    passActiveDate(activeDate) {
        const monthAfterPress = activeDate.getMonth();
        console.log(monthAfterPress);
    }

    formatMonthTitle(d, locale) {
        return `${d.getMonth() + 1}/${d.getFullYear}`
    }

    handleSlotChangeEmeaUK(e, emeaSelectedDate) {
        let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaFindIndex !== -1) {
            emeaNewSlot[emeaFindIndex].MaxSlotUK = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaNewSlot
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaNewSlot
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaNewSlot
                })
            }
        }
        else { // Initialize slots
            let emeaNewSlotObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotUK: e.target.value,
                //MaxSlotBenelux: e.target.value,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
                CurrentSlotUK: 0,
                CurrentSlotBenelux: 0,
                CurrentSlotDE: 0,
                CurrentSlotFR: 0,
                CurrentSlotCH: 0,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat(emeaNewSlotObj) : this.state.slotsEmeaPro.concat(emeaNewSlotObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaJoined
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaJoined
                })
            }
        }
        let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
        let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaNewModIndex !== -1) {
            emeaNewModdate[emeaNewModIndex].MaxSlotUK = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaNewModdate,
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaNewModdate,
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaNewModdate,
                })
            }
        }
        else { // Set defaults
            let emeaNewModObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotUK: e.target.value,
                //MaxSlotBenelux: e.target.value,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaJoined
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaJoined
                })
            }
        }
    }


    handleSlotChangeEmeaBenelux(e, emeaSelectedDate) {
        let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaFindIndex !== -1) {
            emeaNewSlot[emeaFindIndex].MaxSlotBenelux = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaNewSlot
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaNewSlot
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaNewSlot
                })
            }
        }
        else { // Initialize slots
            let emeaNewSlotObj = {
                DateTimeValue: emeaSelectedDate,
                //MaxSlotUK: e.target.value,
                MaxSlotBenelux: e.target.value,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
                CurrentSlotUK: 0,
                CurrentSlotBenelux: 0,
                CurrentSlotDE: 0,
                CurrentSlotFR: 0,
                CurrentSlotCH: 0,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat(emeaNewSlotObj) : this.state.slotsEmeaPro.concat(emeaNewSlotObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaJoined
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaJoined
                })
            }
        }
        let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
        let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaNewModIndex !== -1) {
            emeaNewModdate[emeaNewModIndex].MaxSlotBenelux = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaNewModdate,
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaNewModdate,
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaNewModdate,
                })
            }
        }
        else { // Set defaults
            let emeaNewModObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotBenelux: e.target.value,
                //MaxSlotUK: e.target.value,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaJoined
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaJoined
                })
            }
        }
    }


    handleSlotChangeEmeaDE(e, emeaSelectedDate) {
        let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaFindIndex !== -1) {
            emeaNewSlot[emeaFindIndex].MaxSlotDE = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaNewSlot
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaNewSlot
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaNewSlot
                })
            }
        }
        else { // Initialize slots
            let emeaNewSlotObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotDE: e.target.value,
                //MaxSlotFR: e.target.value,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
                CurrentSlotDE: 0,
                CurrentSlotFR: 0,
                CurrentSlotUK: 0,
                CurrentSlotBenelux: 0,
                CurrentSlotCH: 0,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat(emeaNewSlotObj) : this.state.slotsEmeaPro.concat(emeaNewSlotObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaJoined
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaJoined
                })
            }
        }
        let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
        let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaNewModIndex !== -1) {
            emeaNewModdate[emeaNewModIndex].MaxSlotDE = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaNewModdate,
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaNewModdate,
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaNewModdate,
                })
            }
        }
        else { // Set defaults
            let emeaNewModObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotDE: e.target.value,
                //MaxSlotFR: e.target.value,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaJoined
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaJoined
                })
            }
        }
    }

    handleSlotChangeEmeaFR(e, emeaSelectedDate) {
        let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaFindIndex !== -1) {
            emeaNewSlot[emeaFindIndex].MaxSlotFR = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaNewSlot
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaNewSlot
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaNewSlot
                })
            }
        }
        else { // Initialize slots
            let emeaNewSlotObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotFR: e.target.value,
                //MaxSlotDE: e.target.value,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
                CurrentSlotDE: 0,
                CurrentSlotFR: 0,   
                CurrentSlotUK: 0,
                CurrentSlotBenelux: 0,
                CurrentSlotCH: 0,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat(emeaNewSlotObj) : this.state.slotsEmeaPro.concat(emeaNewSlotObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaJoined
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaJoined
                })
            }
        }
        let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
        let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaNewModIndex !== -1) {
            emeaNewModdate[emeaNewModIndex].MaxSlotFR = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaNewModdate,
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaNewModdate,
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaNewModdate,
                })
            }
        }
        else { // Set defaults
            let emeaNewModObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotFR: e.target.value,
               //MaxSlotDE: e.target.value,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaJoined
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaJoined
                })
            }
        }
    }

    handleSlotChangeEmeaCH(e, emeaSelectedDate) {
        let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaFindIndex !== -1) {
            emeaNewSlot[emeaFindIndex].MaxSlotCH = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaNewSlot
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaNewSlot
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaNewSlot
                })
            }
        }
        else { // Initialize slots
            let emeaNewSlotObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotCH: e.target.value,
                //MaxSlotIT: e.target.value,
                //MaxSlotIT: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_IT : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_IT : proMaxSlots_IT,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
                CurrentSlotCH: 0,
                //CurrentSlotIT: 0,
                CurrentSlotDE: 0,
                CurrentSlotFR: 0,
                CurrentSlotUK: 0,
                CurrentSlotBenelux: 0,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat(emeaNewSlotObj) : this.state.slotsEmeaPro.concat(emeaNewSlotObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    slotsEmeaCORP: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    slotsEmeaField: emeaJoined
                })
            }
            else {
                this.setState({
                    slotsEmeaPro: emeaJoined
                })
            }
        }
        let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
        let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
        if (emeaNewModIndex !== -1) {
            emeaNewModdate[emeaNewModIndex].MaxSlotCH = e.target.value;
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaNewModdate,
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaNewModdate,
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaNewModdate,
                })
            }
        }
        else { // Set defaults
            let emeaNewModObj = {
                DateTimeValue: emeaSelectedDate,
                MaxSlotCH: e.target.value,
                //MaxSlotIT: e.target.value,
                //MaxSlotIT: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_IT : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_IT : proMaxSlots_IT,
                MaxSlotDE: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_DE : proMaxSlots_DE,
                MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
                MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
                MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
            }
            let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
            if (this.state.LOB === 'EMEA CORP') {
                this.setState({
                    modifiedDatesEMEACorp: emeaJoined
                })
            }
            else if (this.state.LOB === 'EMEA FIELD') {
                this.setState({
                    modifiedDatesEMEAField: emeaJoined
                })
            }
            else {
                this.setState({
                    modifiedDatesEMEAPro: emeaJoined
                })
            }
        }
    }

    //handleSlotChangeEmeaIT(e, emeaSelectedDate) {
    //    let emeaNewSlot = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
    //    let emeaFindIndex = emeaNewSlot.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
    //    if (emeaFindIndex !== -1) {
    //        emeaNewSlot[emeaFindIndex].MaxSlotBenelux = e.target.value;
    //        if (this.state.LOB === 'EMEA CORP') {
    //            this.setState({
    //                slotsEmeaCORP: emeaNewSlot
    //            })
    //        }
    //        else if (this.state.LOB === 'EMEA FIELD') {
    //            this.setState({
    //                slotsEmeaField: emeaNewSlot
    //            })
    //        }
    //        else {
    //            this.setState({
    //                slotsEmeaPro: emeaNewSlot
    //            })
    //        }
    //    }
    //    else { // Initialize slots
    //        let emeaNewSlotObj = {
    //            DateTimeValue: emeaSelectedDate,
    //            MaxSlotIT: e.target.value,
    //            //MaxSlotCA: e.target.value,
    //            MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
    //            MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
    //            MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
    //            MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
    //            CurrentSlotCH: 0,
    //            CurrentSlotIT: 0,
    //            CurrentSlotDE: 0,
    //            CurrentSlotFR: 0,
    //            CurrentSlotUK: 0,
    //            CurrentSlotBenelux: 0,
    //        }
    //        let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP.concat(emeaNewSlotObj) : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField.concat() : this.state.slotsEmeaPro.concat();
    //        if (this.state.LOB === 'EMEA CORP') {
    //            this.setState({
    //                slotsEmeaCORP: emeaJoined
    //            })
    //        }
    //        else if (this.state.LOB === 'EMEA FIELD') {
    //            this.setState({
    //                slotsEmeaField: emeaJoined
    //            })
    //        }
    //        else {
    //            this.setState({
    //                slotsEmeaPro: emeaJoined
    //            })
    //        }
    //    }
    //    let emeaNewModdate = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField : this.state.modifiedDatesEMEAPro;
    //    let emeaNewModIndex = emeaNewModdate.findIndex(_ => _.DateTimeValue === emeaSelectedDate);
    //    if (emeaNewModIndex !== -1) {
    //        emeaNewModdate[emeaNewModIndex].MaxSlotBenelux = e.target.value;
    //        if (this.state.LOB === 'EMEA CORP') {
    //            this.setState({
    //                modifiedDatesEMEACorp: emeaNewModdate,
    //            })
    //        }
    //        else if (this.state.LOB === 'EMEA FIELD') {
    //            this.setState({
    //                modifiedDatesEMEAField: emeaNewModdate,
    //            })
    //        }
    //        else {
    //            this.setState({
    //                modifiedDatesEMEAPro: emeaNewModdate,
    //            })
    //        }
    //    }
    //    else { // Set defaults
    //        let emeaNewModObj = {
    //            DateTimeValue: emeaSelectedDate,
    //            MaxSlotIT: e.target.value,
    //            //MaxSlotCH: e.target.value,
    //            MaxSlotCH: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_CH : proMaxSlots_CH,
    //            MaxSlotFR: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_FR : proMaxSlots_FR,
    //            MaxSlotUK: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_UK : proMaxSlots_UK,
    //            MaxSlotBenelux: this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA FIELD' ? fieldMaxSlots_Benelux : proMaxSlots_Benelux,
    //        }
    //        let emeaJoined = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp.concat(emeaNewModObj) : this.state.LOB === 'EMEA FIELD' ? this.state.modifiedDatesEMEAField.concat(emeaNewModObj) : this.state.modifiedDatesEMEAPro.concat(emeaNewModObj);
    //        if (this.state.LOB === 'EMEA CORP') {
    //            this.setState({
    //                modifiedDatesEMEACorp: emeaJoined
    //            })
    //        }
    //        else if (this.state.LOB === 'EMEA FIELD') {
    //            this.setState({
    //                modifiedDatesEMEAField: emeaJoined
    //            })
    //        }
    //        else {
    //            this.setState({
    //                modifiedDatesEMEAPro: emeaJoined
    //            })
    //        }
    //    }
    //}

    handleSlotChangeUS(e, selectedDate) {
        let newSlot = this.state.LOB === 'CORP' ? this.state.slotsCORP : this.state.LOB === 'FIELD' ? this.state.slotsField : this.state.slotsPro;
        let foundIndex = newSlot.findIndex(_ => _.DateTimeValue === selectedDate);
        if (foundIndex !== -1) {
            newSlot[foundIndex].MaxSlotUS = e.target.value;
            if (this.state.LOB === 'CORP') {
                this.setState({
                    slotsCORP: newSlot,
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    slotsField: newSlot,
                })
            }
            else {
                this.setState({
                    slotsPro: newSlot,
                })
            }
        }
        else { // Initialize slots
            let newSlotObj = {
                DateTimeValue: selectedDate,
                MaxSlotUS: e.target.value,
                MaxSlotCA: this.state.LOB === 'CORP' ? corpMaxSlots_CA : this.state.LOB === 'PRO' ? proMaxSlots_CA : fieldMaxSlots_CA,
                CurrentSlotUS: 0,
                CurrentSlotCA: 0,
            }
            //let joined = this.state.slots.concat(newSlotObj);
            let joined = this.state.LOB === 'CORP' ? this.state.slotsCORP.concat(newSlotObj) : this.state.LOB === 'FIELD' ? this.state.slotsField.concat(newSlotObj) : this.state.slotsPro.concat(newSlotObj);
            if (this.state.LOB === 'CORP') {
                this.setState({
                    slotsCORP: joined
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    slotsField: joined
                })
            }
            else {
                this.setState({
                    slotsPro: joined
                })
            }
        }
        let newModified = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP : this.state.LOB === 'FIELD' ? this.state.modifiedDatesField : this.state.modifiedDatesPro;
        let modifiedIndex = newModified.findIndex(_ => _.DateTimeValue === selectedDate);
        if (modifiedIndex !== -1) {
            newModified[modifiedIndex].MaxSlotUS = e.target.value;
            if (this.state.LOB === 'CORP') {
                this.setState({
                    modifiedDatesCORP: newModified,
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    modifiedDatesField: newModified,
                })
            }
            else {
                this.setState({
                    modifiedDatesPro: newModified,
                })
            }
        }
        else { // Set slot defaults
            let newModifiedObj = {
                DateTimeValue: selectedDate,
                MaxSlotUS: e.target.value,
                MaxSlotCA: this.state.LOB === 'CORP' ? corpMaxSlots_CA : this.state.LOB === 'PRO' ? proMaxSlots_CA : fieldMaxSlots_CA,
            }
            //let joined = this.state.modifiedDates.concat(newModifiedObj);
            let joined = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP.concat(newModifiedObj) : this.state.LOB === 'FIELD' ? this.state.modifiedDatesField.concat(newModifiedObj) : this.state.modifiedDatesPro.concat(newModifiedObj);
            if (this.state.LOB === 'CORP') {
                this.setState({
                    modifiedDatesCORP: joined,
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    modifiedDatesField: joined,
                })
            }
            else {
                this.setState({
                    modifiedDatesPro: joined
                })
            }
        }
    }

    handleSlotChangeCA(e, selectedDate) {
        let newSlot = this.state.LOB === 'CORP' ? this.state.slotsCORP : this.state.LOB === 'FIELD' ? this.state.slotsField : this.state.slotsPro;
        let foundIndex = newSlot.findIndex(_ => _.DateTimeValue === selectedDate);
        if (foundIndex !== -1) {
            newSlot[foundIndex].MaxSlotCA = e.target.value;
            if (this.state.LOB === 'CORP') {
                this.setState({
                    slotsCORP: newSlot,
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    slotsField: newSlot,
                })
            }
            else {
                this.setState({
                    slotsPro: newSlot,
                })
            }
        }
        else { // Initialize slots
            let newSlotObj = {
                DateTimeValue: selectedDate,
                MaxSlotCA: e.target.value,
                MaxSlotUS: this.state.LOB === 'CORP' ? corpMaxSlots_US : this.state.LOB === 'PRO' ? proMaxSlots_US : fieldMaxSlots_US,
                CurrentSlotUS: 0,
                CurrentSlotCA: 0,
            }
            //let joined = this.state.slots.concat(newSlotObj);
            let joined = this.state.LOB === 'CORP' ? this.state.slotsCORP.concat(newSlotObj) : this.state.LOB === 'FIELD' ? this.state.slotsField.concat(newSlotObj) : this.state.slotsPro.concat(newSlotObj);
            if (this.state.LOB === 'CORP') {
                this.setState({
                    slotsCORP: joined
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    slotsField: joined
                })
            }
            else {
                this.setState({
                    slotsPro: joined
                })
            }
        }
        let newModified = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP : this.state.LOB === 'FIELD' ? this.state.modifiedDatesField : this.state.modifiedDatesPro;
        let modifiedIndex = newModified.findIndex(_ => _.DateTimeValue === selectedDate);
        if (modifiedIndex !== -1) {
            newModified[modifiedIndex].MaxSlotCA = e.target.value;
            if (this.state.LOB === 'CORP') {
                this.setState({
                    modifiedDatesCORP: newModified,
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    modifiedDatesField: newModified,
                })
            }
            else {
                this.setState({
                    modifiedDatesPro: newModified,
                })
            }
        }
        else { // Set slot defaults
            let newModifiedObj = {
                DateTimeValue: selectedDate,
                MaxSlotCA: e.target.value,
                MaxSlotUS: this.state.LOB === 'CORP' ? corpMaxSlots_US : this.state.LOB === 'PRO' ? proMaxSlots_US : fieldMaxSlots_US,

            }
            //let joined = this.state.modifiedDates.concat(newModifiedObj);
            let joined = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP.concat(newModifiedObj) : this.state.LOB === 'FIELD' ? this.state.modifiedDatesField.concat(newModifiedObj) : this.state.modifiedDatesPro.concat(newModifiedObj);
            if (this.state.LOB === 'CORP') {
                this.setState({
                    modifiedDatesCORP: joined
                })
            }
            else if (this.state.LOB === 'FIELD') {
                this.setState({
                    modifiedDatesField: joined
                })
            }
            else {
                this.setState({
                    modifiedDatesPro: joined
                })
            }
        }
    }

    handleEmeaDateSelected() {
        let slots = this.state.LOB === 'EMEA CORP' ? this.state.slotsEmeaCORP : this.state.LOB === 'EMEA FIELD' ? this.state.slotsEmeaField : this.state.slotsEmeaPro;
        let emeaSelectedDate = new Date(this.state.emeaSelectedDate).toLocaleDateString();
        if (this.state.region === "EMEA") {
            if (this.state.emeaSelectedDate) {
                let slot = slots.find(_ => _.DateTimeValue === emeaSelectedDate)
                return (
                    <React.Fragment>
                        <Form.Field>
                            <label className='selecteddate'>
                                Selected Date: {emeaSelectedDate}
                            </label>
                        </Form.Field>
                        <Grid className='emeagrid'>
                            <Grid.Column >
                                <Form.Field inline /*className='selecteddate'*/>
                                    <label> UK/Ireland - Max: </label>
                                    <Input
                                        type="number"
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                        value={slot ? slot.MaxSlotUK : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA PRO' ? proMaxSlots_UK : fieldMaxSlots_UK}
                                        onChange={(e) => this.handleSlotChangeEmeaUK(e, emeaSelectedDate)}
                                        name='UKSlot'
                                        className='emaemaximput'
                                    />
                                    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotUK : 0}</label>
                                    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotUK - slot.CurrentSlotUK : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA PRO' ? proMaxSlots_UK : fieldMaxSlots_UK}</label>
                                </Form.Field>
                                <Form.Field inline /*className='selecteddate'*/>
                                    <label>Germany - Max: </label>
                                    <Input
                                        type="number"
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                        value={slot ? slot.MaxSlotDE : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA PRO' ? proMaxSlots_DE : fieldMaxSlots_DE}
                                        onChange={(e) => this.handleSlotChangeEmeaDE(e, emeaSelectedDate)}
                                        name='DESlot'
                                        className='emaemaximput'
                                    />
                                    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotDE : 0}</label>
                                    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotDE - slot.CurrentSlotDE : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_DE : this.state.LOB === 'EMEA PRO' ? proMaxSlots_DE : fieldMaxSlots_DE}</label>
                                </Form.Field>
                                <Form.Field inline /*className='selecteddate'*/>
                                    <label>France- Max: </label>
                                    <Input
                                        type="number"
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                        value={slot ? slot.MaxSlotFR : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA PRO' ? proMaxSlots_FR : fieldMaxSlots_FR}
                                        onChange={(e) => this.handleSlotChangeEmeaFR(e, emeaSelectedDate)}
                                        name='FRSlot'
                                        className='emaemaximput'
                                    />
                                    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotFR : 0}</label>
                                    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotFR - slot.CurrentSlotFR : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_FR : this.state.LOB === 'EMEA PRO' ?proMaxSlots_FR : fieldMaxSlots_FR}</label>
                                </Form.Field>
                            </Grid.Column>
                            <Grid.Column >
                                <Form.Field inline /*className='selecteddate'*/>
                                    <label>Benelux - Max: </label>
                                    <Input
                                        type="number"
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                        value={slot ? slot.MaxSlotBenelux : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA PRO' ? proMaxSlots_Benelux : fieldMaxSlots_Benelux}
                                        onChange={(e) => this.handleSlotChangeEmeaBenelux(e, emeaSelectedDate)}
                                        name='BeneluxSlot'
                                        className='emaemaximput'
                                    />
                                    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotBenelux : 0}</label>
                                    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotBenelux - slot.CurrentSlotBenelux : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_Benelux : this.state.LOB === 'EMEA PRO' ? proMaxSlots_Benelux : fieldMaxSlots_Benelux}</label>
                                </Form.Field>
                                <Form.Field inline /*className='selecteddate'*/>
                                    <label>Switzerland - Max: </label>
                                    <Input
                                        type="number"
                                        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                        value={slot ? slot.MaxSlotCH : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA PRO' ? proMaxSlots_CH : fieldMaxSlots_CH}
                                        onChange={(e) => this.handleSlotChangeEmeaCH(e, emeaSelectedDate)}
                                        name='CHSlot'
                                        className='emaemaximput'
                                    />
                                    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotCH : 0}</label>
                                    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotCH - slot.CurrentSlotCH : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_CH : this.state.LOB === 'EMEA PRO' ? proMaxSlots_CH : fieldMaxSlots_CH}</label>
                                </Form.Field>
                                {/*<Form.Field inline className='selecteddate'>*/}
                                {/*    <label> Italy - Max: </label>*/}
                                {/*    <Input*/}
                                {/*        type="number"*/}
                                {/*        onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}*/}
                                {/*        onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}*/}
                                {/*        value={slot ? slot.MaxSlotIT : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_IT : this.state.LOB === 'EMEA PRO' ? proMaxSlots_IT : fieldMaxSlots_IT}*/}
                                {/*        onChange={(e) => this.handleSlotChangeEmeaIT(e, emeaSelectedDate)}*/}
                                {/*        name='ITSlot'*/}
                                {/*        className='emaemaximput'*/}
                                {/*    />*/}
                                {/*    <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotUK : 0}</label>*/}
                                {/*    <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotUK - slot.CurrentSlotUK : this.state.LOB === 'EMEA CORP' ? corpMaxSlots_UK : this.state.LOB === 'EMEA PRO' ? proMaxSlots_UK : fieldMaxSlots_UK}</label>*/}
                                {/*</Form.Field>*/}
                            </Grid.Column>
                        </Grid>
                    </React.Fragment>
                )
            }
        }
    }

    handleNaDateSelected() {
        let slots = this.state.LOB === 'CORP' ? this.state.slotsCORP : this.state.LOB === 'FIELD' ? this.state.slotsField : this.state.slotsPro;
        let selectedDate = new Date(this.state.selectedDay).toLocaleDateString();
        if (this.state.region === "NA") {
            if (this.state.selectedDay) {
                let slot = slots.find(_ => _.DateTimeValue === selectedDate)
                return (
                    <React.Fragment>
                        <Form.Field>
                            <label className='selecteddate'>
                                Selected Date: {selectedDate}
                            </label>
                        </Form.Field>
                        <Form.Field inline className='selecteddate'>
                            <label>US - Max: </label>
                            <Input
                                type="number"
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                value={slot ? slot.MaxSlotUS : this.state.LOB === 'CORP' ? corpMaxSlots_US : this.state.LOB === 'PRO' ? proMaxSlots_US : fieldMaxSlots_US}
                                onChange={(e) => this.handleSlotChangeUS(e, selectedDate)}
                                name='USSlot'
                                className='maxinput'
                            />
                            <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotUS : 0}</label>
                            <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotUS - slot.CurrentSlotUS : this.state.LOB === 'CORP' ? corpMaxSlots_US : this.state.LOB === 'PRO' ? proMaxSlots_US : fieldMaxSlots_US}</label>
                        </Form.Field>
                        <Form.Field inline className="selecteddate">
                            <label>CA - Max: </label>
                            <Input
                                type="number"
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '.' || evt.key === '+' || evt.key === '-') && evt.preventDefault()}
                                onInput={(e) => { e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 11) }}
                                value={slot ? slot.MaxSlotCA : this.state.LOB === 'CORP' ? corpMaxSlots_CA : this.state.LOB === 'PRO' ? proMaxSlots_CA : fieldMaxSlots_CA}
                                onChange={(e) => this.handleSlotChangeCA(e, selectedDate)}
                                name='CASlot'
                                className='maxinput'
                            />
                            <label>&nbsp;&nbsp; Filled: {slot ? slot.CurrentSlotCA : 0}</label>
                            <label>&nbsp;&nbsp; Available: {slot ? slot.MaxSlotCA - slot.CurrentSlotCA : this.state.LOB === 'CORP' ? corpMaxSlots_CA : this.state.LOB === 'PRO' ? proMaxSlots_CA : fieldMaxSlots_CA}</label>
                        </Form.Field>
                    </React.Fragment>
                )
            }
        }
    }

    handleEMEARadio() {
        if (this.state.region === "EMEA") {
            return (
                <React.Fragment>
                    <Form className='adminForms'>
                        <Form.Field className='adminformText'>
                            <p className='adminRadioButtonText'> Select line of business:</p>
                        </Form.Field>
                        <Form.Field className='dockform'>
                            <Radio className='adminRadioButton'
                                label='EMEA CORP'
                                name='radioGroupLOBManageHardware'
                                value='EMEA CORP'
                                checked={this.state.LOB === 'EMEA CORP'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                            <Radio className='adminRadioButton'
                                label='EMEA PRO'
                                name='radioGroupLOBManageHardware'
                                value='EMEA PRO'
                                checked={this.state.LOB === 'EMEA PRO'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                            <Radio className='adminRadioButton'
                                label='EMEA FIELD'
                                name='radioGroupLOBManageHardware'
                                value='EMEA FIELD'
                                checked={this.state.LOB === 'EMEA FIELD'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                        </Form.Field>

                    </Form>
                </React.Fragment>
            )
        }
    }

    handleNARadio() {
        if (this.state.region === 'NA')
            return (
                <React.Fragment>
                    <Form className='adminForms'>
                        <Form.Field className='adminformText'>
                            <p className='adminRadioButtonText'> Select line of business:</p>
                        </Form.Field>
                        <Form.Field className='dockform'>
                            <Radio className='adminRadioButton'
                                label='CORP'
                                name='radioGroupLOBManageHardware'
                                value='CORP'
                                checked={this.state.LOB === 'CORP'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                            <Radio className='adminRadioButton'
                                label='PROTIVITI'
                                name='radioGroupLOBManageHardware'
                                value='PRO'
                                checked={this.state.LOB === 'PRO'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                            <Radio className='adminRadioButton'
                                label='FIELD'
                                name='radioGroupLOBManageHardware'
                                value='FIELD'
                                checked={this.state.LOB === 'FIELD'}
                                onChange={(e, value) => this.handleLOBChange(e, value)}
                            />
                        </Form.Field>
                    </Form>
                </React.Fragment>
            )
    }

    handleLOBChange(e, value) {
        this.setState({
            LOB: value.value,
        })
    }

    handleEMEADay() {
        if (this.state.region === 'EMEA') {
            return (
                <React.Fragment>
                    <DayPicker
                        mode="single"
                        selected={this.state.selectedDay}
                        onSelect={(day) => this.setState({ selectedDay: day })}
                        numberOfMonths={2}
                        //selectedDays={new Date(this.state.selectedDay)}
                        onDayClick={this.handleEMEADayClick}
                        //formatMonthTitle
                        disabled={[
                            { dayOfWeek: [0, 2, 3, 4, 5, 6] }, // disables all non-Mondays
                        ]}
                        month={this.state.month}
                        onInteraction={this.handleDaySelect}
                        onMonthChange={this.handleMonthChange}
                        value={this.date}
                        onChange={(d) => { this.onChange(d) }}
                        className={this.state.LOB === 'CORP' ? 'CORP' : this.state.LOB === 'PRO' ? 'PRO' : 'FIELD'}
                    />
                </React.Fragment>
            )
        }
    }

    handleNADay() {
        if (this.state.region === 'NA') {
            return (
                <React.Fragment>
                    <DayPicker
                        mode="single"
                        selected={this.state.selectedDay}
                        onSelect={(day) => this.setState({ selectedDay: day })}
                        numberOfMonths={2}
                        selectedDays={new Date(this.state.selectedDay)}
                        onDayClick={this.handleDayClick}
                        formatMonthTitle
                        disabled={[
                            { dayOfWeek: [0, 2, 3, 4, 5, 6] }, // disables all non-Mondays
                        ]}
                        month={this.state.month}
                        onInteraction={this.handleDaySelect}
                        onMonthChange={this.handleMonthChange}
                        value={this.date}
                        onChange={(d) => { this.onChange(d) }}
                        className={this.state.LOB === 'CORP' ? 'CORP' : this.state.LOB === 'PRO' ? 'PRO' : 'FIELD'}
                    />
                </React.Fragment>
            )
        }
    }

    render() {
        if (this.state.loading)
            return (
                <div className="center-me">
                    <Dimmer active inverted>
                        <Loader size='huge'>Getting All The Available Dates...</Loader>
                    </Dimmer>
                </div>
            )

        //const modDates = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP.map : this.state.modifiedDatesPro.map((d) => <ul key={d.DateTimeValue}> {d.DateTimeValue}: US - {d.MaxSlotUS} CA: - {d.MaxSlotsCA}</ul>)
        //const modDates = this.state.modifiedDates.map((d) => <ul key={d.DateTimeValue}> {d.DateTimeValue}: US - {d.MaxSlotUS} CA: - {d.MaxSlotCA} </ul>);

        let emeaModDates = this.state.LOB === 'EMEA CORP' ? this.state.modifiedDatesEMEACorp : this.state.LOB === 'EMEA PRO' ? this.state.modifiedDatesEMEAPro : this.state.modifiedDatesEMEAField;
        let modDates = this.state.LOB === 'CORP' ? this.state.modifiedDatesCORP : this.state.LOB === 'PRO' ? this.state.modifiedDatesPro : this.state.modifiedDatesField;
        if (this.state.LOB === 'CORP') {
            modDates = this.state.modifiedDatesCORP.map((d) => <ul key={d.DateTimeValue}> {d.DateTimeValue}: US - {d.MaxSlotUS} CA - {d.MaxSlotCA} </ul>);
        }
        else if (this.state.LOB === 'PRO') {
            modDates = this.state.modifiedDatesPro.map((d) => <ul key={d.DateTimeValue}> {d.DateTimeValue}: US - {d.MaxSlotUS} CA - {d.MaxSlotCA} </ul>);
        }
        else if (this.state.LOB === 'EMEA CORP') {
            emeaModDates = this.state.modifiedDatesEMEACorp.map((d) => <List key={d.DateTimeValue}> {d.DateTimeValue}: <ListItem>Ben - {d.MaxSlotBenelux}</ListItem> <ListItem>CH - {d.MaxSlotCH}</ListItem> <ListItem>DE - {d.MaxSlotDE}</ListItem> <ListItem>FR - {d.MaxSlotFR}</ListItem>  <ListItem>UK - {d.MaxSlotUK}</ListItem></List>);
        }
        else if (this.state.LOB === 'EMEA PRO') {
            emeaModDates = this.state.modifiedDatesEMEAPro.map((d) => <List key={d.DateTimeValue}> {d.DateTimeValue}: <ListItem>Ben - {d.MaxSlotBenelux}</ListItem> <ListItem>CH - {d.MaxSlotCH}</ListItem> <ListItem>DE - {d.MaxSlotDE}</ListItem> <ListItem>FR - {d.MaxSlotFR}</ListItem>  <ListItem>UK - {d.MaxSlotUK}</ListItem></List>);
        }
        else if (this.state.LOB === 'EMEA FIELD') {
            emeaModDates = this.state.modifiedDatesEMEAField.map((d) => <List key={d.DateTimeValue}> {d.DateTimeValue}: <ListItem>Ben - {d.MaxSlotBenelux}</ListItem> <ListItem>CH - {d.MaxSlotCH}</ListItem> <ListItem>DE - {d.MaxSlotDE}</ListItem> <ListItem>FR - {d.MaxSlotFR}</ListItem>  <ListItem>UK - {d.MaxSlotUK}</ListItem></List>);
        }
        else {
            modDates = this.state.modifiedDatesField.map((d) => <ul key={d.DateTimeValue}> {d.DateTimeValue}: US - {d.MaxSlotUS} CA - {d.MaxSlotCA} </ul>);
        }
        return (

            <div className='outer-container'>
                <div className='inner-container'>
                    <DualHeader />


                    <h1 className="h1Cal"> Manage Calendar </h1>

                    {this.handleNARadio()}
                    {this.handleEMEARadio()}
                    <div className="calwrapper">
                        <div className="leftside">
                            {this.handleEMEADay()}
                            {this.handleNADay()}
                            {/*<DayPicker*/}
                            {/*    numberOfMonths={2}*/}
                            {/*    selectedDays={new Date(this.state.selectedDay)}*/}
                            {/*    onDayClick={this.handleDayClick}*/}
                            {/*    formatMonthTitle*/}
                            {/*    disabledDays={this.state.disabledDates}*/}
                            {/*    month={this.state.month}*/}
                            {/*    onInteraction={this.handleDaySelect}*/}
                            {/*    onMonthChange={this.handleMonthChange}*/}
                            {/*    modifiers={*/}
                            {/*        {*/}
                            {/*            monday: { daysOfWeek: [1] }*/}
                            {/*        }*/}
                            {/*    }*/}
                            {/*    value={this.date}*/}
                            {/*    onChange={(d) => { this.onChange(d) }}*/}
                            {/*    className={this.state.LOB === 'CORP' ? 'CORP' : this.state.LOB === 'PRO' ? 'PRO' : 'FIELD'}*/}
                            {/*/>*/}

                            <Form /*className="MangeCalendarDateInput"*/>
                                {this.handleEmeaDateSelected()}
                                {this.handleNaDateSelected()}
                            </Form>


                        </div>

                        <div className="rightside">
                            <div className="HeaderStrings">
                                <h2>Modified Dates - {this.state.LOB === 'CORP' ? 'Corporate' : '' || this.state.LOB === 'FIELD' ? 'Field' : '' || this.state.LOB === 'PRO' ? 'Protiviti' : '' || this.state.LOB === 'EMEA CORP' ? 'EMEA Corporate' : '' || this.state.LOB === 'EMEA PRO' ? 'EMEA Protiviti' : '' || this.state.LOB === 'EMEA FIELD' ? 'EMEA Field': ''}</h2>
                                <div className="ModifiedDates">
                                    {modDates}
                                    {emeaModDates}
                                </div>
                            </div>


                            <Form className="DateInput"  >

                                <Button
                                    type='submit'
                                    color="green"
                                    onClick={this.handleCalClickBack}
                                    className="calbackbutton">
                                    <i class="left arrow icon"></i> Back
                                </Button>

                                <Button
                                    type='submit'
                                    required
                                    color="green"
                                    onClick={this.handleSave}
                                    className="nextbtton"
                                >
                                    Save
                                    <i class="right arrow icon">
                                    </i>
                                </Button>
                            </Form>

                        </div>
                    </div>

                </div>
                <DualFooter />
            </div>

        );
    }
}

export default connect()(ManageCalendar);
